/**
 * Ignore all elements except the html2pdf__ <br />
 * This class has structure as html2pdf__overlay => html2pdf__container => cloned html element to be rendered
 */
export class Html2PdfIgnorer {
  private html2pdfOverlay: HTMLElement;

  private headTag: HTMLElement;

  private readonly htmlToBeRender: HTMLElement;

  constructor(htmlToBeRender: HTMLElement) {
    this.htmlToBeRender = htmlToBeRender;
  }

  shouldIgnoreElement(element: HTMLElement): boolean {
    if (
      element.className &&
      element.className.includes &&
      element.className?.includes('html2pdf__overlay')
    ) {
      this.html2pdfOverlay = element;
    }

    /** Should include styling in head tag **/
    if (element.tagName?.toLowerCase() === 'head') {
      this.headTag = element;
      return false;
    }

    if (this.headTag && this.headTag.contains(element)) {
      return false;
    }

    /** Should include parent's node so html2pdf can scan to node to render  **/
    if (element.contains(this.htmlToBeRender)) {
      return false;
    }

    /**
     * Should include elements in html2pdf overlay only to improve export performance
     *  html2pdf will clone the element to render deeply & wrap it it overlay & container class
     *  however, it's different from original element to render
     *  so we can skip those, and only need html2pdf cloning from overlay element
     **/
    if (!this.html2pdfOverlay) {
      return true;
    }

    if (this.html2pdfOverlay.contains(element)) {
      return false;
    }

    return true;
  }
}
